import React from 'react';

import errorIcon from '../../../assets/myAccount/input-error-icon.svg';

import './PetCloudInput.css';

export const PetCloudInputErrorLabel = ({
  errorClassName = '',
  renderError = null,
  error = '',
}) => {
  if (!error) {
    return null;
  }

  return (
    <p className={`PetCloudInput-error ${errorClassName}`}>
      {renderError ? renderError(error) : (
        <>
          <img alt="" src={errorIcon} />

          <span>{error}</span>
        </>
      )}
    </p>
  );
};

const PetCloudInput = ({
  ariaProps,
  className,
  disabled = false,
  error = '',
  errorClassName = '',
  inputName,
  inputRef,
  isTextArea = false,
  maxLength,
  onBlur,
  onChange,
  onFocus,
  onKeyPress,
  onPaste,
  optionalText = '',
  options = [],
  placeholder,
  renderError,
  title,
  type = 'text',
  value = '',
  ...inputProps
}) => {
  const renderInput = () => {
    if (isTextArea) {
      return (
        <textarea
          ref={inputRef}
          className={`PetCloudInput-input ${className || ''} `
            + `${error && 'Input-error'} ${disabled && 'Input-disabled'}`}
          disabled={disabled}
          maxLength={maxLength}
          name={inputName}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          value={value || ''}
          {...ariaProps}
        />
      );
    }

    if (type === 'select') {
      return (
        <select
          ref={inputRef}
          className={`PetCloudInput-input ${className || ''} `
            + `${error ? 'Input-error' : ''} ${disabled && 'Input-disabled'}`
            + ` ${value === '' ? 'PetCloudInput-input-placeholder' : ''}`}
          disabled={disabled}
          name={inputName}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          value={value || ''}
          {...ariaProps}
          {...inputProps}
        >
          <option value="">{placeholder}</option>

          {options.map((opt) => (
            <option value={opt.value} {...opt}>{opt.label}</option>
          ))}
        </select>
      );
    }

    return (
      <input
        ref={inputRef}
        className={`PetCloudInput-input ${className || ''} `
          + `${error ? 'Input-error' : ''} ${disabled && 'Input-disabled'}`}
        disabled={disabled}
        maxLength={maxLength}
        name={inputName}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        onPaste={onPaste}
        placeholder={placeholder}
        type={type}
        value={value || ''}
        {...ariaProps}
        {...inputProps}
      />
    );
  };

  return (
    <div className="PetCloudInput-main-container">
      {title && (
        <div className="PetCloudInput-title-container">
          <h6 className="PetCloudInput-title">{title}</h6>

          <span className="PetCloudInput-optional">{optionalText}</span>
        </div>
      )}

      {renderInput()}

      <PetCloudInputErrorLabel
        error={error}
        errorClassName={errorClassName}
        renderError={renderError}
      />
    </div>
  );
};

export { PetCloudInput };
